import {
    GET_ALL_TECHNOLOGIES
} from './constants';

const initialState = {
    allTechnology: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_TECHNOLOGIES: {
            return {
                ...state,
                allTechnology: action.payload,
            };
        }
        default:
            return state;
    }
};

